module.exports = __webpack_public_path__ + "media/store/fonts/BeausiteClassic-Regular_web-da35ffe5d917f1b686b116333ea4eb11.woff";